import * as React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { ArrayItem } from "./ArrayItem";
import { IParameterListProps, ParameterList } from "./ParameterList";

const SortableItem = SortableElement(({ ...props }: { itemIndex: number } & SortableComponentProps & IParameterListProps) => {
    const keyWithIndex = props.parameterKey + "[" + props.itemIndex + "]";
    const handleItemDelete = () => {
        props.onArrayItemRemove(props.parameterKey, props.itemIndex);
    };

    return <div
        className="show-on-hover-container parameter-array-element"
        key={keyWithIndex + "_count_" + props.items.length}
    >
        {!props.isForCompletion && <ArrayItem
            id={keyWithIndex}
            onDeleteClick={handleItemDelete}
        />}
        <ParameterList
            {...props}
            parentName={keyWithIndex}
            argumentJson={props.argumentJson?.parameterTemplate}
            isParentArrayParemeter={true}
        />
    </div>;
});

const SortableList = SortableContainer(({ ...props }: SortableComponentProps & IParameterListProps) => {
    return (
        <div className="bpmn-array-editor">
            {props.items.map((value: any, index: any) => {
                return <SortableItem
                    {...props}
                    key={`item-${index + props.parameterKey + props.items.length}`}
                    index={index}
                    itemIndex={index}
                />;
            })}
        </div>
    );
});

export class SortableComponent extends React.Component<SortableComponentProps & IParameterListProps, {}> {

    public render() {
        return <SortableList getContainer={this.getContainer as any} onSortEnd={this.onSortEnd} {...this.props} useDragHandle={true} />;
    }

    private onSortEnd = ({ oldIndex, newIndex }: { oldIndex: any, newIndex: any }) => {
        this.props.onArrayItemIndexChange(this.props.parameterKey, oldIndex, newIndex);
    }

    private getContainer = () => {
        return document.getElementById(this.props.parameterContainerId);
    }
}

interface SortableComponentProps {
    items: any;
    parameterKey: string | undefined;
    parameterContainerId: string;
}
